import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import ScreenLoading from 'components/ScreenLoading'
import BookmarkNavigationMenu from 'components/Bookmarks/NavigationBookmarks'
import useQuery from 'containers/useQuery'
import { useSidebarCtx } from 'containers/SidebarContext'
import { BookmarksContext } from 'containers/bookmarks/BookmarksContext'

const ReportList = ({
  embedReportsFetchStatus,
  embedReports,
  currentOrganization,
  currentReportSlug,
  onReportOpen,
  navigationBookmarks,
  fetchingBookmark,
}) => {
  const [openedNavigationMenu, setOpenedNavigationMenu] = useState(null)
  const [activeReport, setActiveReport] = useState(null)
  const history = useHistory()
  const query = useQuery()
  const { collapseSidebar } = useSidebarCtx()
  const { activeBookmark, setActiveBookmark } = useContext(BookmarksContext)

  const handleClickReport = (e, report) => { 
    const classList = e.target.classList
    if (!classList.contains('report-header') && !classList.contains("report")) return;
    setOpenedNavigationMenu(null)
    const destination = `/organization/${currentOrganization.slug}/dashboard/${report.slug}`
    if (currentReportSlug !== report.slug) {
      history.push(destination)
      setActiveBookmark(null)
    }
    setOpenedNavigationMenu(report.slug)
    onReportOpen(report.name)
  }
  
  const handleGoToReportBookmark = (reportSlug, bookmark) => {
    let mainPath = `/organization/${currentOrganization.slug}/`
    if (bookmark.show_demo) {
      // mainPath += `demo/Demo/${bookmark?.slug}`
      mainPath += `dashboard/${reportSlug}/-demo`
    }
    else {
      mainPath += `dashboard/${reportSlug}/${bookmark?.slug}`
    }
    history.push(mainPath)
    collapseSidebar(true)
    setOpenedNavigationMenu(null)
    setActiveBookmark(bookmark)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.report-list')) {
        setOpenedNavigationMenu(null)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    // get report slug from pathname
    const reportSlug = window.location.pathname.split('/').pop()
    const report = embedReports.find((r) => r.slug === reportSlug)
    if (report) {
      setActiveReport(report)
    } else {
      setActiveReport(null)
    }
  }, [query, navigationBookmarks, window.location.pathname])

  if (embedReportsFetchStatus === 'pending') {
    return <ScreenLoading />
  }
  return (
    <ul className="sub-navigation report-list">
      {embedReports.length > 0 ?
      embedReports.map((report) => {
        return (
          <>
            <li
              key={report.id}
              className={`report ${
                currentReportSlug === report.slug ? 'active' : ''
              }`}
              onClick={(e) => handleClickReport(e, report)}
              onMouseEnter={(e) => {
                setOpenedNavigationMenu(report.slug)
              }}
            ><div className="report-header">
            
              {currentReportSlug === report.slug &&
              !currentOrganization.is_demo &&
              report.access_level === 'Edit' ? (
                <p>
                  {report.name[0] === '-' ? report.name.slice(1) : report.name}{' '}
                  {report.demo && <span className="demo-tag">DEMO</span>}
                </p>
              ) : (
                <>
                  {report.name[0] === '-' ? report.name.slice(1) : report.name}{' '}
                  {report.demo && <span className="demo-tag">DEMO</span>}
                </>
              )}
              {/* {navigationBookmarks.filter(
                  (bookmark) =>
                    !bookmark?.reports?.length ||
                    bookmark?.reports?.some((r) => r.slug === report.slug)
                ).length > 0 && ( */}
              {navigationBookmarks?.length > 0 && (
                <span className="material-icons-outlined">
                  keyboard_arrow_right
                </span>
              )}
              {openedNavigationMenu === report.slug && (
                <BookmarkNavigationMenu
                  bookmarks={navigationBookmarks}
                  fetchingBookmark={fetchingBookmark}
                  handleGoToReportBookmark={handleGoToReportBookmark}
                  openedNavigationMenu={openedNavigationMenu}
                  report={report}
                  key={report.slug}
                  />
                )}
            </div>
              {(activeReport?.slug === report?.slug) && activeBookmark !== null ? <p className="report-active-navigation">{activeBookmark?.name}</p> : <></>}
            </li>
          </>
        )
      })
      :
      <li>No reports</li>
    }
    </ul>
  )
}

export default React.memo(ReportList)